function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPage = function SvgIconPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m763.948 256.209-4.256-3.144H755v7.847h8.948v-4.703Z",
    style: {
      fill: "none",
      strokeWidth: "1.03px"
    },
    transform: "matrix(1.63591 0 0 2.2146 -1229.944 -557.552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.948 253.065H755l8.948 7.847v-7.847Z",
    style: {
      fill: "none",
      strokeWidth: "2.4px"
    },
    transform: "matrix(-.77806 0 0 -.88718 607.238 234.361)"
  }));
};
export default SvgIconPage;